import React from 'react';
import PropTypes from 'prop-types';

import {NavLink} from 'react-router-dom';

import {DataCell, IconNewTab24, Row, TextCell} from 'pac-ux-components';


const UserAgreementsTable = ({ agreements }) => (<React.Fragment>
                        <Row
                          columns='2fr 1fr 1fr 1fr 1fr'
                          gap="8px"
                          isHeader={true}
                          selected={false}
                          striped="none"
                          className="p-3"
                        >
                            <TextCell value="Name" /> 
                            <TextCell value="View" /> 
                            <TextCell value="Accepted By" /> 
                            <TextCell value="Accepted On" /> 
                            <TextCell value="From IP" />
                        </Row>
                        {Array.isArray(agreements) && agreements.map((agreement, index) => {
                            return (
                                <Row
                                  columns='2fr 1fr 1fr 1fr 1fr'
                                  gap="8px"
                                  isHeader={false}
                                  selected={false}
                                  striped="odd"
                                  className="p-3"
                                  key={index}
                                >
                                    <TextCell value={agreement.name} /> 
                                    <DataCell><NavLink to={agreement.viewPath}><IconNewTab24 /></NavLink></DataCell> 
                                    <TextCell value={agreement.acceptedBy} /> 
                                    <TextCell value={agreement.acceptedOn} /> 
                                    <TextCell value={agreement.acceptedIpAddress} />
                                </Row>
                            );
                        })}
                </React.Fragment>);


export default UserAgreementsTable;


UserAgreementsTable.propTypes = {
    agreements: PropTypes.array,
};
